import React from 'react'
import CountUp from 'react-countup'
import { useInView } from 'react-intersection-observer'

function TrustBarTechDigit() {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: 0.28,
        rootMargin: '0px 0px -40px 0px',
    })

    const duration = 2.4

    return (
        <div ref={ref} className="trust-bar-techdigit td-section td-section--trust rts-section-gap">
            <div className="container">
                <div className="row g-4 g-lg-4 align-items-stretch">
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="trust-stat-card">
                            <div className="trust-stat-icon" aria-hidden="true">
                                <i className="fas fa-calendar-check" />
                            </div>
                            <h3 className="trust-stat-value">
                                {inView ? (
                                    <CountUp start={0} end={5} duration={duration} decimals={0} suffix="+ Years" />
                                ) : (
                                    <span>0+ Years</span>
                                )}
                            </h3>
                            <p className="trust-stat-label">In Operations</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="trust-stat-card">
                            <div className="trust-stat-icon" aria-hidden="true">
                                <i className="fas fa-chart-line" />
                            </div>
                            <h3 className="trust-stat-value">
                                {inView ? (
                                    <CountUp start={0} end={95} duration={duration} decimals={0} suffix="%+" />
                                ) : (
                                    <span>0%+</span>
                                )}
                            </h3>
                            <p className="trust-stat-label">Client Retention Rate</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="trust-stat-card">
                            <div className="trust-stat-icon" aria-hidden="true">
                                <i className="fas fa-stopwatch" />
                            </div>
                            <h3 className="trust-stat-value trust-stat-value--range">
                                {inView ? (
                                    <>
                                        <CountUp start={0} end={24} duration={duration} decimals={0} />
                                        <span className="trust-stat-value__dash">{'\u2013'}</span>
                                        <CountUp start={0} end={48} duration={duration} decimals={0} />
                                        <span className="trust-stat-value__suffix"> hrs</span>
                                    </>
                                ) : (
                                    <span>{'0\u20130 hrs'}</span>
                                )}
                            </h3>
                            <p className="trust-stat-label">Claims Processing Time</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                        <div className="trust-stat-card">
                            <div className="trust-stat-icon" aria-hidden="true">
                                <i className="fas fa-users" />
                            </div>
                            <h3 className="trust-stat-value">
                                {inView ? (
                                    <CountUp start={0} end={25} duration={duration} decimals={0} suffix="+" />
                                ) : (
                                    <span>0+</span>
                                )}
                            </h3>
                            <p className="trust-stat-label">Clients Served</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TrustBarTechDigit
